import React from 'react';
import { ExpandIcon } from './expand';
import { isCustomExpand } from './common';

export default function Cell({ customCell, cellProps, index, expandable = {} }) {
  const { row, getValue, column } = cellProps;
  const alignItems = column.columnDef.alignItems ?? 'center';
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems }}>
      {index === 0 && !isCustomExpand(expandable) && (
        <div style={{ paddingLeft: `${row.depth * 2}rem` }}>
          <ExpandIcon row={row} />
        </div>
      )}
      {customCell ? customCell(row.original, row.index) : getValue()}
    </div>
  );
}
